const MINUTE = 60_000;

/** 서버의 보수적 갱신 기준에 여유를 두며, 이를 실제 URL 만료 시각으로 사용하지 않는다. */
export function getEbsRefreshAt(
  refreshAfter: string | null | undefined,
  requestedAt: number,
  service: 'PRIMARY' | 'MIDDLE' | 'ESOFT',
): number | null {
  if (service === 'ESOFT') return null;
  const serverTime = refreshAfter ? Date.parse(refreshAfter) : NaN;
  return Math.min(Number.isFinite(serverTime) ? serverTime - 30_000 : Infinity, requestedAt + 110 * MINUTE);
}

/** 재생 주소의 인증 query/fragment가 APM 또는 오류 신고에 남지 않도록 한다. */
export function redactVideoUrl(value: string): string {
  return value.split(/[?#]/, 1)[0];
}

// 서명 query/fragment는 보관하지 않는다. 갱신·unmount 뒤 늦게 도착한 미디어 오류도
// 정리할 수 있도록 이 문서가 열린 동안 발급받은 경로를 유지한다.
const ebsVideoResources = new Set<string>();

function getVideoResourceKey(value: string): string | undefined {
  try {
    const url = new URL(value);
    if (url.protocol === 'https:' && !url.username && !url.password) return url.origin + url.pathname;
  } catch {
    // URL이 아닌 진단 값은 등록하거나 마스킹하지 않는다.
  }
}

/** 재생 API의 응답을 플레이어에 전달하기 전에 호출한다. 고정 CDN 목록은 필요하지 않다. */
export function registerEbsVideoUrl(value: string): void {
  if (typeof window === 'undefined') return;
  const key = getVideoResourceKey(value);
  if (key) ebsVideoResources.add(key);
}

/** 실제 발급받은 EBS 리소스만 마스킹하며 다른 경로의 진단 정보는 보존한다. */
export function redactEbsVideoUrl(value: string): string {
  const key = getVideoResourceKey(value);
  return key && ebsVideoResources.has(key) ? redactVideoUrl(value) : value;
}
